import React, {useCallback} from "react";
import {useTranslation} from "react-i18next";
import EditItemDropdown from "../../EditItemDropdown";

export type Props = Omit<React.ComponentProps<typeof EditItemDropdown.Action>, "onClick" | "as"> & {
  onReanalyseStart: () => void;
  isVisible?: boolean;
};

export default function ReanalyseCompetenceResultsDropdownAction({onReanalyseStart, isVisible, ...props}: Props) {
  const {t} = useTranslation();
  const handleStartReanalyse = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    onReanalyseStart();
  }, [onReanalyseStart]);

  if (isVisible === false) return null;

  return (
    <EditItemDropdown.Action
      title={t("components.ReanalyseCompetenceResultsDropdownAction.title")}
      onClick={handleStartReanalyse}
      {...props}
    />
  );
}
